// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'government';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.875 10.688h-2.25v4.5h2.25zm5.25 0h-2.25v4.5h2.25zm5.25 0h-2.25v4.5h2.25z' />
    <path d='M16.313 10.042a.653.653 0 0 1-.645.645H2.332a.645.645 0 0 1-.187-1.267l6.637-2.04a.75.75 0 0 1 .435 0l6.638 2.04a.652.652 0 0 1 .457.622z' />
    <path d='M11.625 6.188H13.5V8.7m-9 0V6.187h1.875' />
    <path d='M4.5 6.188a4.5 4.5 0 0 1 9 0M9 .563v1.125M.563 17.438h16.875M1.5 15.188h15' />
  </g>
);

export const viewBox = '0 0 18 18';
